import React, { useState , useRef , useEffect} from "react";
import axios from 'axios';
import { Modal, Button } from "react-bootstrap";
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import PropComponent from "./PropComponent";
import PartnerComponent from "./PartnerComponent";
import CompanyComponent from "./CompanyComponent";
import '../../CssFiles/appTimeline.css';
import {lostReasonMap, loanTypeMap, stageValMap, stagePriorityMap} from '../../utils'
import Cookies from 'universal-cookie';

function CRMComponent() {
    const [selectedOption, setSelectedOption] = useState('GLID');
    const [val, setVal] = useState('');
    const [user, setUser] = useState('105257');
    const [pwd, setPwd] = useState('');
    const [showUI, setShowUI] = useState(false);
    const [wrongCred,setWrongCred] = useState('')
    const [glid,setGlid] = useState('');
    const [mobNo,setMobNo] = useState('');
    const [showInfo,setShowInfo] = useState(false);
    const [piInfo,setPiInfo] = useState([]);
    const [submitErr,setSubmitErr] = useState('');
    const [fromDate, setFromDate] = useState(new Date());
    const [toDate,setToDate] = useState(new Date());
    const [allApp,setAllApp] = useState([]);
    const [appTime,setAppTime] = useState([]);
    const [pdfArr,setPdfArr] = useState([]);
    const [bankArrState,setBankArrState] = useState([]);
    const [respGlid,setRespGlid] = useState('');
    const [isUploaded,setIsUploaded] = useState('');
    const [isAnalysed,setIsAnalysed] = useState('');
    const [isNBR,setIsNBR] = useState('');
    const [show,setShow] = useState(false);
    const [kycArr,setKycArr] = useState([]);
    const [isViewVisible,setIsViewVisible] = useState(false);
    const [constSubmit,setConstSubmit] = useState(false);

    const [uploadedFile, setUploadedFile] = useState(null);
    const [analysedFile,setAnalysedFile] = useState(null);

    const [uploadedText,setUploadedText] = useState('');
    const [analysedText,setAnalysedText] = useState('');
    const [constitutionType,setConstitutionType] = useState('');

    const [docPwd,setDocPwd] = useState('');

    const bankingRef = useRef(null);
    const analysedRef = useRef(null);

    const [selectType,setSelectType] = useState("raw");
    const [isChecked, setIsChecked] = useState(false);
    const [gstArr,setGstArr] = useState([]);
    // const today = new Date().toISOString().split('T')[0];
    const hasDivRenderedRef = useRef(false);
    const hasFinalStatusRenderedRef = useRef(false);
    const tatRef = useRef(false);
    const [maxTAT,setMaxTAT] = useState([]);
    const [invalidLogin,setInvalidLogin] = useState('');
    const cookie = new Cookies();

    useEffect(() => {
        if (gstArr["gstin_number"]) {
            checkGSTConditions();
        }
    }, [gstArr]);

    useEffect(() => {
        if (appTime) {
          processAppTime(appTime);
        }
    }, [appTime]);

    useEffect(() => {
        const fetchDecryptedValues = async () => {
            try {
                let encrEmpId = cookie.get('adminiil');
                let encrToken = cookie.get('im_iss');
                let expiryTime = localStorage.getItem("im_iss_expiry");
                const currentTime = Date.now();
                console.log(currentTime);
    
                if (encrEmpId && encrToken && currentTime < expiryTime) {
                    let resp = await validateEncValFunc(encrEmpId, encrToken);
                    console.log(resp);
                    if (resp) {
                        setShowUI(true);
                    }
                } else if (!encrEmpId) {
                    console.log("Adminiil is absent.");
                } else if (!encrToken) {
                    console.log("Token is absent.");
                } else if (currentTime > expiryTime) {
                    console.log("Token Expired");
                }
            } catch (error) {
                console.log("Error fetching decrypted values:", error);
            }
        };
    
        const initializeGoogleSignIn = () => {
            if (window.google) {
                window.google.accounts.id.initialize({
                    client_id: '64436141311-sqmnhrukrqjf0sq4qmkcjp156jmd82hf.apps.googleusercontent.com', 
                    callback: handleCredentialResponse,
                });
            }
        };
    
        const loadGoogleSignInScript = () => {
            if (!window.google) {
                const script = document.createElement('script');
                script.src = 'https://accounts.google.com/gsi/client';
                script.async = true;
                script.defer = true;
                script.onload = initializeGoogleSignIn;
                document.body.appendChild(script);
            } else {
                initializeGoogleSignIn();
            }
        };
    
        fetchDecryptedValues();
        loadGoogleSignInScript();
    }, []);

    const [showTimelineDetails, setShowTimelineDetails] = useState(false);
    const [selectedAppId, setSelectedAppId] = useState(null);
    const [selectedTimeLender, setSelectedTimeLender] = useState(null);
    const [newAppTime,setNewAppTime] = useState([]);

    const formatDate = (uploadDate) => {
        if (uploadDate) {
            const date = new Date(uploadDate);
            const day = String(date.getDate()).padStart(2, '0');
            const month = String(date.getMonth() + 1).padStart(2, '0'); 
            const year = date.getFullYear();
        
            const formattedDate = `${day}-${month}-${year}`;

            return formattedDate;
        }
        
    }

    const handleGlidChange = (event) => {
        setGlid(event.target.value)
    };

    const handleMobChange = (event) => {
        setMobNo(event.target.value)
    };

    const handleUserChange = () => {
        setUser("105257");
    };

    const handlePwdChange = (event) => {
        setPwd(event.target.value);
    };

    const handleRadioChange = (event) => {
        setSelectType(event.target.value);
    };

    const checkDateDiff = (strDt) => {
        const [day, month, year] = strDt.split('-');
        const givenDate = new Date(`${year}-${month}-${day}`);
        const today = new Date();

        const timeDiff = today.getTime() - givenDate.getTime();

        const dayDiff = Math.ceil(timeDiff / (1000 * 3600 * 24));

        return dayDiff < 15;
    }

    const handleDocPwdChange = (event) => {
        setDocPwd(event.target.value)
    };

    const handleDownloadClick = (url) => {
        if(url !== ""){
            var host = window.location.hostname;

            if(host == 'loans.indiamart.com'){
                var apiURL = "https://loans.indiamart.com/api/v1/viewDoc";
            }
            else {
                var apiURL = "https://dev-loans.indiamart.com/api/v1/viewDoc";
            }

            var inData = {
                "url":url
            };

            axios({
                method: 'post',
                headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
                url: apiURL,
                data: inData,
                timeout:2000
            }).then(function (response) {
                if(response.data.CODE === "200"){
                    window.open(response.data.PDF_URL,'_blank');
                }
            }).catch(function (error) {
                console.log(error);
            });
        }
    };

    const getKYCInfo = async(upload_flag = '') => {             //used in KycComp
        var host = window.location.hostname;

        if(host == 'loans.indiamart.com'){
            var apiURL = "https://loans.indiamart.com/api/v1/getKYC";
        }
        else{
            var apiURL = "https://dev-loans.indiamart.com/api/v1/getKYC";
        }

        var postData = {
            "glid":glid,
            "const_type":upload_flag
        };

        const formData = new FormData();
        for (const key in postData) {
            if (postData.hasOwnProperty(key)) {
                formData.append(key, postData[key]);
            }
        }

        axios({
            method: 'post',
            headers: {  'Content-Type': 'multipart/form-data', },
            url: apiURL,
            data: formData,
            timeout:2000
            }).then(function (response) {
                var resp = response.data;
                if(resp.CODE == "200" && resp.OUTPUT){
                    setKycArr(resp.OUTPUT);
                    setIsViewVisible(true);
                }
                else{
                    setKycArr([]);
                    setIsViewVisible(false);
                }
            }).catch(function (error) {
                console.log(error);
            });
    };

    const parseDate = (dateStr) => {
        const [day, month, year] = dateStr.split('-'); 
        return new Date(`${year}-${month}-${day}`); 
      };

    const uploadAnalyse = (bankArr) => {
        var isUploadedVar = 'No';
        var isAnalysedVar = 'No';
        var uploadedFlag, analysedFlag = false;
        var rawInitialDuration0, rawInitialDuration1;

        if(bankArr !== undefined && bankArr !== null && bankArr.length > 0){
            for(var i = 0; i < bankArr.length; i++){
                if(bankArr[i]["docStage"] == "raw" && !uploadedFlag){
                    var res = bankArr[i]["duration"].split("to").map(part => part.trim());
    
                    if(checkDateDiff(res[1])){
                        isUploadedVar = 'Yes'
                        rawInitialDuration0 = parseDate(res[0]);
                        rawInitialDuration1 = parseDate(res[1]);
                        uploadedFlag = true;
                    }
                    else{
                        isUploadedVar = 'Old'
                    }
                }
                else if(bankArr[i]["docStage"] === "analyzed" && !analysedFlag){
                    var res = bankArr[i]["duration"].split("to").map(part => part.trim());
    
                    if(checkDateDiff(res[1])){
                        isAnalysedVar = 'Yes'
                        analysedFlag = true;
                    }
                    else{
                        isAnalysedVar = 'Old'
                    }
                }
            }
        }
        
        if(isUploadedVar === 'Yes'){
            setIsNBR('No');
        }
        else{
            setIsNBR('Yes');
        }

        if(isUploadedVar == 'Yes' && isAnalysedVar == 'No'){
            setSelectType("analyzed");
            setFromDate(rawInitialDuration0)
            setToDate(rawInitialDuration1)
        }

        setIsUploaded(isUploadedVar);
        setIsAnalysed(isAnalysedVar);
    };

    const handleSubmitClick = (flag = "") => {
        if(flag === "refresh"){
            const today = new Date();
            setAnalysedText('')
            setUploadedText('')
            setFromDate(today)
            setToDate(today)
            setDocPwd('')
            setIsChecked(false)
            setSelectType("raw")
            if (bankingRef.current) {
                bankingRef.current.value = ''; 
                setUploadedFile(null)
            }

            if (analysedRef.current) {
                analysedRef.current.value = ''; 
                setAnalysedFile(null)
            }
        }
        setConstSubmit(false)
        setConstitutionType('');

        if(mobNo != "" && glid != ""){
            setMobNo('')
        }

        if(mobNo != "" || glid != ""){
            setSubmitErr('');
            var host = window.location.hostname;

            if(host == 'loans.indiamart.com'){
                var apiURL = "https://loans.indiamart.com/api/v1/getInfo";
            }
            else if(host == 'dev-loans.indiamart.com'){
                var apiURL = "https://dev-loans.indiamart.com/api/v1/getInfo";
            }
            else{
                var apiURL = "https://dev-loans.indiamart.com/api/v1/getInfo";
            }

            var inData = {
                "flag": (glid !== "") ? "glid" : "mob",
                "val" : (glid !== "") ? glid : mobNo
            };

            // if(user != "" && pwd != ""){
            axios({
                method: 'post',
                headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
                url: apiURL,
                data: JSON.stringify(inData),
                timeout:2000
                }).then(function (response) {
                    setShowInfo(true)
                    var resp = response.data;
                    
                    setAllApp(resp["allApp"]);                    
                    var timeArr = resp["appTimeline"]
                    setAppTime(resp["appTimeline"])

                    const date = new Date(Date.UTC(2019, 3, 1));
                    var isoDateString = date.toISOString();
                    const maxDates = {};

                    if(timeArr !== null && timeArr !== undefined){
                        timeArr.forEach(item => {
                        if (item.event === "Stage Updated") {
                            const appId = item.appId;
                            const eventDate = new Date(item.date);

                            if (!maxDates[appId] || eventDate > maxDates[appId]) {
                                maxDates[appId] = eventDate; 
                            }
                        }
                        });
                    }

                    setMaxTAT(maxDates);

                    setAppTime(timeArr)
                    setRespGlid(resp["glid"]);
                    setSelectType("raw");
                    setFromDate(new Date())
                    setToDate(new Date())
                    var bankArr = resp["banking"];
                    setBankArrState(bankArr)
                    uploadAnalyse(bankArr)
                    gstApiFunc()
                }).catch(function (error) {
                    console.log(error);
                });
            // }
        }
        else{
            setSubmitErr("Both fields empty");
        }
    };

    const handleAppTimelineClick = (appLicationId, lender) =>{
        setSelectedAppId(appLicationId);
        setSelectedTimeLender(lender);
        setShowTimelineDetails(true);
    }

    const handleAppTimelineClose = () =>{
        setSelectedAppId(null);
        setSelectedTimeLender(null);
        setShowTimelineDetails(false);
        hasFinalStatusRenderedRef.current = false;
        hasDivRenderedRef.current = false;
        tatRef.current = false;
    }

    const handleAuthorizeClick = () => {
        // setShowUI(true) //to be removed
        var host = window.location.hostname;

        if(host == 'loans.indiamart.com'){
            var apiURL = "https://loans.indiamart.com/api/v1/crmAuthorize";
        }
        else if(host == 'dev-loans.indiamart.com'){
            var apiURL = "https://dev-loans.indiamart.com/api/v1/crmAuthorize";
        }
        else{
            // setUser("95071")
            // setPwd("1")
            // setShowUI(true)
            var apiURL = "https://dev-loans.indiamart.com/api/v1/crmAuthorize";
        }

        var inData = {
            "user" : user,
            "pwd" : pwd,
        };

        if(user != "" && pwd != ""){
            axios({
                method: 'post',
                headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
                url: apiURL,
                data: JSON.stringify(inData),
                timeout:2000
                }).then(function (response) {
                    if(response.data.CODE == "200"){
                        setShowUI(true)
                    }
                    else{
                        setWrongCred(response.data.ERROR)
                    }
                }).catch(function (error) {
                    console.log(error);
                    setWrongCred("Something went wrong. Please try again.")
                });
        }else{
            if(user == ""){
                setWrongCred("Please enter username")
            }
            else if(pwd == ""){
                setWrongCred("Please enter password")
            }
        }
    };

    const handleBankingChange = (event) => {
        const file = event.target.files[0];
        setUploadedFile(file);
    };

    const handleAnalysedChange = (event) => {
        const file = event.target.files[0];
        setAnalysedFile(file);
    }

    const dateToString = (date) => {
        if (!date) return '';
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are zero-based
        const day = String(date.getDate()).padStart(2, '0');
        return `${day}-${month}-${year}`;
    };

    const handleUploadBankingClick = () => {
        if (uploadedFile == null) {
            setUploadedText('Please upload the document.')
            return
        }

        setUploadedText('');

        if(docPwd !== ''){
            setDocPwd('');
        }

        var host = window.location.hostname;

        if(host == 'loans.indiamart.com'){
            var apiURL = "https://loans.indiamart.com/api/v1/uploadBanking";
        }
        else{
            var apiURL = "https://dev-loans.indiamart.com/api/v1/uploadBanking";
        }

        var postData = {
            "glid":respGlid,
            "docStage":"raw",
            "docType":"pdf",
            // "docUrl":"abcdef",
            "uploaderId":"105257",
            "duration":dateToString(fromDate) + " to " + dateToString(toDate),
            "file": uploadedFile,
            "docCredentials":docPwd
        };
        const formData = new FormData();
        for (const key in postData) {
            if (postData.hasOwnProperty(key)) {
                formData.append(key, postData[key]);
            }
        }
        
        axios({
            method: 'post',
            headers: {  'Content-Type': 'multipart/form-data', },
            url: apiURL,
            data: formData,
            timeout:2000
            }).then(function (response) {
                setShowInfo(true)
                var resp = response.data;
                if(resp.CODE == "200"){
                    setUploadedText("Banking Uploaded Successfully.")
                }
                else{
                    setUploadedText("Something went wrong. Please try again.")
                }
                bankingRef.current.value = null;
                setUploadedFile(null);
                handleSubmitClick("refresh");
            }).catch(function (error) {
                console.log(error);
            });
    };

    const handleUploadAnalysedClick = () => {
        if (analysedFile == null) {
            setAnalysedText('Please upload the document.')
            return
        }

        setAnalysedText('');
        if(docPwd !== ''){
            setDocPwd('');
        }

        var host = window.location.hostname;

        if(host == 'loans.indiamart.com'){
            var apiURL = "https://loans.indiamart.com/api/v1/uploadBanking";
        }
        else{
            var apiURL = "https://dev-loans.indiamart.com/api/v1/uploadBanking";
        }

        var fileType = analysedFile.type;

        if (fileType === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet') {
            fileType = 'xlsx';
        } else if (fileType === 'application/vnd.ms-excel') {
            fileType = 'xls';
        } else if(fileType === 'text/csv'){
            fileType = 'csv';
        } 
        else {
            fileType = 'Unknown';
        }

        var postData = {
            "glid":respGlid,
            "docStage":"analyzed",
            "docType":fileType,
            // "docUrl":"abcdef",
            "uploaderId":"105257",
            "docCredentials":docPwd,
            "duration":dateToString(fromDate) + " to " + dateToString(toDate),
            "file": analysedFile
        };
        const formData = new FormData();
        for (const key in postData) {
            if (postData.hasOwnProperty(key)) {
                formData.append(key, postData[key]);
            }
        }
        
        axios({
            method: 'post',
            headers: {  'Content-Type': 'multipart/form-data', },
            url: apiURL,
            data: formData,
            timeout:2000
            }).then(function (response) {
                setShowInfo(true)
                var resp = response.data;
                if(resp.CODE == "200"){
                    analysedRef.current.value = null;
                    setAnalysedText("Analysed Doc Uploaded Successfully.")
                }
                else{
                    setAnalysedText("Something went wrong. Please try again.")
                }
                setAnalysedFile();
                handleSubmitClick("refresh");
            }).catch(function (error) {
                console.log(error);
            });
    };

    const handleViewClick = () => {
        setAnalysedText('')
        setUploadedText('')
        setShow(true);
    };

    const gstApiFunc = async() => {
        var host = window.location.hostname;
        if (host == 'loans.indiamart.com') {
            var getgstDataURL = "https://loans.indiamart.com/api/v1/getGSTData";
        }
        else {
            var getgstDataURL = "https://dev-loans.indiamart.com/api/v1/getGSTData";
        }
    
        var getgstData = {
            "glid": glid,
        };
    
        try{
            let response = await axios({
                method: 'post',
                headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
                url: getgstDataURL,
                data: JSON.stringify(getgstData),
                timeout: 10000
            });

            var gstValues = response.data.data.values;
            if(response.data.code !== undefined && response.data.code !== null && response.data.code == '200'){
                setGstArr(gstValues);
            }
            else{
                setGstArr([]);
            }
        }
        catch (error) {
            console.error("An error occurred in utils gstapi call ", error);
        }
    };

    const checkGSTConditions = () => {
        if (gstArr["gstin_number"] && gstArr["gstin_number"].length > 5) {
            if (gstArr["gstin_number"].charAt(5) === "P") {
                getKYCInfo("proprietor");
            } else if (gstArr["gstin_number"].charAt(5) === "F") {
                getKYCInfo("partnership");
            } else if (gstArr["gstin_number"].charAt(5) === "C") {
                getKYCInfo("company");
            }
        }
    };

    const handleConstitutionChange = (event) => {
        setConstitutionType(event.target.value)
    };

    const handleConstitutionSubmitClick = () =>{
        getKYCInfo(constitutionType.toLowerCase());
        setConstSubmit(true);
    };

    const calculateDaysDifference = (datetimeStr1, datetimeStr2, flag = '') => {
        const date1 = new Date(datetimeStr1);
        const date2 = new Date(datetimeStr2);
        
        date1.setHours(0, 0, 0, 0);
        date2.setHours(0, 0, 0, 0);
    
        const timeDifference = date1 - date2;
    
        if(flag === 'dd'){
            console.log(datetimeStr1);
            console.log(datetimeStr2);
            console.log(date1);
            console.log(date2);
            console.log(timeDifference);
        }
        
        const daysDifference = timeDifference / (1000 * 3600 * 24);
    
        return Math.floor(daysDifference);
    };
    

    const processAppTime = (appTime) => {
        const temp = [];
    
        appTime.forEach(item => {
            if (item.event === 'Stage Updated') { 
                let oldStage = 1;
                if(item.oldVal !== ""){
                    oldStage = stagePriorityMap[item.oldVal.toLowerCase()];
                }
                let newStage = stagePriorityMap[item.newVal.toLowerCase()]; 
    
                while (newStage > 1 && newStage <=6 && newStage > oldStage) {
                    const modifiedItem = {
                        ...item, 
                        oldVal: stageValMap[newStage - 1], 
                        newVal: stageValMap[newStage],  
                    };
                    temp.push(modifiedItem);
                    newStage -= 1;
                }
            } else {
                temp.push(item);
            }
        });
        console.log(temp)
        setNewAppTime(temp);
    
        return temp;
    };

    const renderFinalStatus = (data,reason) => {
        if (!hasFinalStatusRenderedRef.current) {
            hasFinalStatusRenderedRef.current = true;
            return (
                <div style={{ marginLeft: '50px', marginBottom: '20px',display:'flex' }}>
                    Final Status <i className="bi bi-arrow-right-short"></i> 
                    <strong>{data} </strong> 
                    {
                        data.toLowerCase() === "rejected" && reason != "" &&
                        <div> &nbsp;({lostReasonMap[reason]})</div>
                    }
                </div>
            );
        }
        return null;
    };

    const renderLoanTable = (amt,roi,tenure) => {
        
        if (!hasDivRenderedRef.current) {
            hasDivRenderedRef.current = true;
            return (
                <div className="col-2" style={{  position: 'absolute', right: '50px', padding: '10px',minWidth:'30%' }}>
                    {   <>
                                                
                        <table style={{...styles.loanDet,minWidth:'75%'}}>
                            <tbody>
                                <tr>
                                    <td className="loanTable" style={styles.labelCell}>Loan Amt</td>
                                    <td className="loanTable" style={styles.valueCell}>
                                        {amt ? <><i className="bi bi-currency-rupee"></i>{amt}</> : "-"}
                                    </td>

                                </tr>
                                <tr>
                                    <td className="loanTable" style={styles.labelCell}>ROI</td>
                                    <td className="loanTable" style={styles.valueCell}>{roi ? `${roi}%` : "-"}</td>
                                </tr>
                                <tr>
                                    <td className="loanTable" style={styles.labelCell}>Tenure</td>
                                    <td className="loanTable" style={styles.valueCell}>
                                        {tenure ? `${tenure} months` : "-"}
                                    </td>

                                </tr>
                            </tbody>
                        </table>

                        </>
                    }
                    
                </div>
            );
        }
        return null;
    };

    const renderTAT = (appDate, maxDate, status, id) => {
        if (!tatRef.current) {
            tatRef.current = true;
    
            const daysDifference = calculateDaysDifference(maxTAT[id], appDate, 'tat');
            console.log(daysDifference)
            if (daysDifference >= 0) {
                return (
                    <div className="col-2" style={{...styles.tatContainer,top: hasDivRenderedRef.current ? '150px' : '55px'}}>
                        Total TAT = {daysDifference} {daysDifference === 1 ? 'day' : 'days'}
                        {status === "In Process" && <p style={styles.countingText}>& counting</p>}
                    </div>
                );
            }
        }
        return null;
    };
    
    const getEmpDetails = async (empEmail) => {
        var host = window.location.hostname;
    
        const apiURL = host === 'loans.indiamart.com'
            ? "https://loans.indiamart.com/api/v1/validateLogin"
            : "https://dev-loans.indiamart.com/api/v1/validateLogin";
    
        var inData = {
            "userEmail": empEmail
        };
    
        try {
            const response = await axios({
                method: 'post',
                headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
                url: apiURL,
                data: JSON.stringify(inData),
                timeout: 2000
            });
    
            if (response.data?.Eid) {
                const expirationDate = new Date();
                expirationDate.setHours(expirationDate.getHours() + 24);
                
                const encEmpID = response.data.Eid;
                const encToken = response.data.t;
                if (encEmpID) {
                    cookie.set('adminiil', encEmpID, { 
                        path: '/', 
                        expires: expirationDate,
                        domain: '.indiamart.com' 
                    });
                }
    
                if (encToken) {
                    cookie.set('im_iss', encToken, { 
                        path: '/', 
                        expires: expirationDate,
                        domain: '.indiamart.com' 
                    });
                    localStorage.setItem('im_iss_expiry', expirationDate.getTime());
                }

                if(encEmpID && encToken){
                    setShowUI(true)
                }
            }
        } catch (error) {
            console.log('Error in getEmpDetails:', error);
        }
    };    

    const validateEncValFunc = async (encEmpId,encToken) => {
        var host = window.location.hostname;
    
        const apiURL = host === 'loans.indiamart.com' 
            ? "https://loans.indiamart.com/api/v1/validateEncValues" 
            : "https://dev-loans.indiamart.com/api/v1/validateEncValues";
    
        var inData = {
            "encEmpId": encEmpId,
            "encToken": encToken
        };
    
        try {
            const response = await axios({
                method: 'post',
                headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
                url: apiURL,
                data: inData,
                timeout: 2000
            });
    
            if (response.data?.CODE === "200") {
                console.log(response.data.FLAG);
                return true;
            } else {
                console.log('Error in response:', response.data);
                return null;
            }
        } catch (error) {
            console.log('Error in getEncDecValue:', error);
            return null;
        }
    }; 

    const handleGoogleClick = () => {
        if (window.google) {
            window.google.accounts.id.prompt(); 
        }
    };

    const handleCredentialResponse = (response) => {
        const jwt = response.credential;
        const base64Url = jwt.split('.')[1];
        const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/'); // Replace URL-safe characters
        const jsonPayload = JSON.parse(decodeURIComponent(escape(atob(base64))));

        const empEmail = jsonPayload.email;
        if(empEmail == "ritvik.trehan@indiamart.com" || empEmail == "aviral.panwar@indiamart.com"){
            getEmpDetails(empEmail)
            setInvalidLogin('');
        } 
        else{
            setInvalidLogin('Please enter a valid Email ID.');
            setTimeout(() => {
                window.location.reload(); 
            }, 2000);
        }
    };

    const stateValues = {respGlid,setRespGlid,styles,gstArr,user,handleDownloadClick,getKYCInfo,kycArr,isViewVisible}
    
    return (
        <>
            {
                !showUI &&
                <div style={styles.container}>
                    <div className="crmLoginDiv">CRM Panel Login</div>
                    <button 
                        onClick={handleGoogleClick}
                        style={styles.googleButton}
                    >
                        <i class="bi bi-google" style={{marginRight:'8px'}}></i>
                        Sign in with Google
                    </button>
                    {
                        invalidLogin != '' &&
                        <div style={{fontSize:'14px',color:'red',margin:'8px auto',textAlign:'center'}}>{invalidLogin}</div>
                    }
                </div>
            }
            {
                showUI &&
                <>
                    <div style={{backgroundColor:'#007BFF',width:'100%',height:'57px',color:'#FFF',display:'flex',justifyContent:'center',alignItems:'center',fontWeight:'bold',fontSize:'24px'}}>CRM Portal</div>

                    <div style={{marginTop:'20px',textAlign:'center'}}>
                        
                        <label>GLID</label>
                        <input type="text" style={{backgroundColor:'#D9D9D9',borderRadius:'8px',height:'40px',width:'150px',marginLeft:'20px',border:'none',paddingLeft:'15px'}} maxLength={12} onChange={handleGlidChange} value={glid}/>

                        <label style={{marginLeft:'80px'}}>Mobile Number</label>
                        <input type="text" style={{backgroundColor:'#D9D9D9',borderRadius:'8px',height:'40px',width:'150px',marginLeft:'20px',border:'none',paddingLeft:'15px'}} maxLength={10} onChange={handleMobChange} value={mobNo}/>

                        <button style={{backgroundColor:'#007BFF',color:'#FFF',borderRadius:'8px',border:'none',padding:'4px 10px',marginLeft:'180px'}} onClick={handleSubmitClick}>SUBMIT</button>

                        <i class="bi bi-arrow-clockwise" style={{float:'right',position:'absolute',fontSize:'24px',right:'100px',display:showInfo ? 'inline-block' : 'none',cursor:'pointer'}} onClick={() => handleSubmitClick("refresh")}></i>
                    </div>

                    {
                        submitErr != '' &&
                        <div style={{color:'red',fontSize:'12px',paddingTop:'10px',paddingLeft:'15px',textAlign:'left'}}>{submitErr}</div>
                    }
                </>
            }
            {
                showInfo && 
                <>
                    <div style={{display: respGlid != '' ? 'flex' : 'none',justifyContent:'center',fontSize:'16px',fontWeight:'700',marginTop:'20px'}}>Showing results for GLID : {respGlid}</div>
                    <div style={{display:'flex',justifyContent:'center'}}>
                        {/* <div style={styles.allSec} id="sec1">
                            <h3 style={{textDecoration:'underline',fontSize:'20px',fontWeight:'bold'}}>PI Information</h3>
                            {piInfo.glusr_id && <p><strong>GLUSR ID:</strong> {piInfo.glusr_id}</p>}
                            {piInfo.full_name.trim() && <p><strong>Full Name:</strong> {piInfo.full_name}</p>}
                            {piInfo.mob_no && <p><strong>Mobile Number:</strong> {piInfo.mob_no}</p>}
                            {piInfo.gst_num && <p><strong>GSTIN:</strong> {piInfo.gst_num}</p>}
                            {piInfo.turnover && <p><strong>GSTIN Turnover:</strong> {piInfo.turnover}</p>}
                            {piInfo.reg_date && <p><strong>GSTIN Reg Date:</strong> {piInfo.reg_date}</p>}
                            {piInfo.pincode && <p><strong>Pincode:</strong> {piInfo.pincode}</p>}
                        </div> */}

                        
                        <div id="allAppList" style={{...styles.midSection,height: isUploaded !== 'No' ? '588px' : '547px',overflowY:'auto',width:'25%'}}>
                            <div style={{fontSize:'18px',fontWeight:'bold',textAlign:'center'}}>All Applications List</div>
                            {allApp && allApp.length > 0 ? (
                                <ol>
                                {allApp.map((app, index) => (
                                    <li key={index} style={{marginTop:'10px',border:'1px solid',padding:'10px',borderRadius:'8px'}}>
                                    <p style={{marginBottom:'0px'}}><strong>Date:</strong> {app.appDate ? formatDate(new Date(app.appDate)) : "N/A"}</p>
                                    <p style={{marginBottom:'0px'}}><strong>Lender Name:</strong> {app.lenderName || 'N/A'}</p>
                                    <p style={{marginBottom:'0px'}}><strong>Status:</strong> {app.status || 'N/A'}</p>
                                    <p style={{marginBottom:'0px'}}><strong>Stage:</strong> {app.stage || 'N/A'}</p>
                                    {app.status == "Rejected" &&
                                    <p style={{marginBottom:'0px'}}><strong>Lost Reason:</strong> {lostReasonMap[app.lostReason] || 'N/A'}</p>}
                                    </li>
                                ))}
                                </ol>
                            ) : (
                                <p style={{textAlign:'center'}}>No applications available.</p>
                            )}
                        </div>
                        
                        <div style={{width:'35%'}} id="sec2">
                            <div id="bureau" style={{...styles.midSection,textAlign:'center'}}>
                                <div style={{fontSize:'18px',fontWeight:'bold'}}>Bureau</div>
                                <div>Pulled: Yes/No</div>
                                <div>Uploaded: Yes/No</div>
                                <div>Bureau Expiring on: Yes/No</div>
                                <div>Bureau Refresh reqd: Yes/No</div>
                                <div>
                                    {/* <label htmlFor="fileUpload" style={{ cursor: 'pointer' }}> */}
                                        {/* <input
                                            type="file"
                                            id="fileUpload"
                                            name="fileUpload[]"
                                            // multiple
                                            accept="application/pdf"
                                            style={styles.fileInput}
                                            // onChange={handleFileChange}
                                        /> */}
                                        <span style={styles.customButton}>
                                            Upload 
                                        </span>
                                    {/* </label> */}
                                    
                                    <button
                                        style={styles.bankingCTA}
                                        onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#0056b3'}
                                        onMouseLeave={(e) => e.currentTarget.style.backgroundColor = '#007BFF'}
                                        
                                    >
                                        View
                                    </button>
                                </div>
                            </div>

                            <div id="banking" style={{...styles.midSection,textAlign:'center'}}>
                                <div style={{fontSize:'18px',fontWeight:'bold'}}>Banking</div>
                                <div>Uploaded: {isUploaded}</div>
                                <div>Analysed: {isAnalysed}</div>
                                <div style={{ marginTop: '10px' }}>
                                    
                                    <div style={{ marginTop: '10px', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                                        <label htmlFor="dateFrom" style={{ marginRight: '10px', fontSize: '16px', fontWeight: 'bold' }}>
                                            From:
                                        </label>
                                        <DatePicker
                                            selected={fromDate}
                                            onChange={(date) => setFromDate(date)}
                                            dateFormat="dd-MM-yyyy"
                                            maxDate={new Date()}
                                            minDate={new Date("2018-01-01")}
                                            className="custom-input" 
                                            calendarClassName="custom-calendar" 
                                            id="fromDate"
                                        />
                                        <label htmlFor="dateTo" style={{ marginLeft: '10px', fontSize: '16px', fontWeight: 'bold',marginRight: '10px' }}>
                                            To:
                                        </label>
                                        
                                        <DatePicker
                                            selected={toDate}
                                            onChange={(date) => setToDate(date)}
                                            dateFormat="dd-MM-yyyy"
                                            maxDate={new Date()}
                                            minDate={fromDate}
                                            className="custom-input" 
                                            calendarClassName="custom-calendar" 
                                            id="toDate"
                                        />
                                    </div>
                                </div>
                                
                                <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center',fontSize:'16px',marginTop:'10px' }}>
                                    <label style={{ display: 'flex', alignItems: 'center', marginRight: '20px' }}>
                                        <input
                                            type="radio"
                                            value="raw"
                                            checked={selectType === "raw"}
                                            onChange={handleRadioChange}
                                            style={{ marginRight: '8px' }}
                                        />
                                        Raw
                                    </label>

                                    <label style={{ display: 'flex', alignItems: 'center' }}>
                                        <input
                                            type="radio"
                                            value="analyzed"
                                            checked={selectType === "analyzed"}
                                            onChange={handleRadioChange}
                                            style={{ marginRight: '8px' }}
                                        />
                                        Analyzed
                                    </label>
                                </div>

                                <div>  
                                    {
                                        selectType === "raw" &&
                                        <div style={{margin:'5px 0px'}}>
                                            <label htmlFor="fileUpload" id="fileUploadLabel" style={{ cursor: 'pointer'}}>
                                                <input
                                                    type="file"
                                                    id="fileUpload"
                                                    name="fileUpload[]"
                                                    // multiple
                                                    accept="application/pdf"
                                                    style={{...styles.fileInput,width:'210px'}}
                                                    onChange={handleBankingChange}
                                                    ref={bankingRef}
                                                />
                                            </label>

                                            
                                            <div style={{margin:'10px 0px'}}>
                                                <label>Doc Pwd:</label>
                                                <input type="text" style={{marginLeft:'5px',borderRadius:'4px',border:'none'}} value={docPwd} onChange={handleDocPwdChange}/>
                                            </div>
                                            
                                            <div style={styles.customButton} onClick={handleUploadBankingClick}>
                                                Upload Banking
                                            </div>

                                            {
                                                uploadedText != '' &&
                                                <div style={{fontSize:'12px',textAlign:'center',color:'#FF1100'}}>{uploadedText}</div>
                                            }
                                        </div>
                                    }

                                    {
                                        selectType === "analyzed" &&
                                        <div style={{margin:'5px 0px'}}>
                                            <label htmlFor="fileUploadAnalysed" style={{ cursor: 'pointer',position:'relative',display:'inline-block'}}>
                                            <input
                                                type="file"
                                                id="fileUploadAnalysed"
                                                name="fileUploadAnalysed[]"
                                                // multiple
                                                accept=".csv, .xls, .xlsx"
                                                style={{...styles.fileInput, width: '210px'}}
                                                onChange={handleAnalysedChange}
                                                ref={analysedRef}
                                            />
                                                
                                            </label>
                                            
                                            
                                            <div style={{margin:'10px 0px'}}>
                                                <label>Doc Pwd:</label>
                                                <input type="text" style={{marginLeft:'5px',borderRadius:'4px',border:'none'}} value={docPwd} onChange={handleDocPwdChange}/>
                                            </div>
                                            
                                            <div style={styles.customButton} onClick={handleUploadAnalysedClick}>
                                                Upload Analysed
                                            </div>

                                            {
                                                analysedText != '' &&
                                                <div style={{fontSize:'12px',textAlign:'center',color:'#FF1100'}}>{analysedText}</div>
                                            }
                                        </div>
                                    }

                                    {
                                        isUploaded !== 'No' &&
                                        <button
                                            // onClick={handleSubmit}
                                            style={styles.bankingCTA}
                                            onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#0056b3'}
                                            onMouseLeave={(e) => e.currentTarget.style.backgroundColor = '#007BFF'}
                                            onClick={handleViewClick}
                                        >
                                            View
                                        </button>
                                    }

                                </div>

                                <div>New Banking Required: {isNBR}</div>

                                
                            </div>

                            
                        </div>

                        <div id="loanTimeline" style={{...styles.allSec,height: isUploaded !== 'No' ? '588px' : '547px',overflowY:'auto'}}>
                        <div style={{fontSize:'18px',fontWeight:'bold',textAlign:'center'}}>Loan Application Timeline</div>
                        
                        <ol>
                                {
                                    appTime && appTime.length > 0 && 
                                    appTime.filter((app, index, self) =>
                                        index === self.findIndex((t) => t.appId === app.appId)
                                      ).map((app, index) =>
                                    (
                                    <li 
                                        key={index} 
                                        style={{
                                            marginTop: '10px', 
                                            border: '1px solid', 
                                            padding: '10px', 
                                            borderRadius: '8px',
                                            cursor:'pointer'
                                        }}

                                        onClick = {() =>handleAppTimelineClick(app.appId, app.lender)}
                                    >
                                        <p style={{ marginBottom: '0px' }}><strong>Updated On:</strong> {app.date ? formatDate(new Date(app.date)) : "N/A"} </p>
                                        <p style={{ marginBottom: '0px' }}><strong>Application Date:</strong> {app.date ? formatDate(new Date(app.appDate)) : "N/A"} </p>
                                        <p style={{ marginBottom: '0px' }}><strong>Lender Name:</strong> {app.lender || 'N/A'}</p>
                                        <p style={{ marginBottom: '0px' }}><strong>Status:</strong> {app.status || 'N/A'}</p>
                                        <p style={{ marginBottom: '0px' }}><strong>Stage:</strong> {app.stage || 'N/A'}</p>
                                        <p style={{marginBottom:'0px'}}><strong>Lead ID:</strong> {app.appId || 'N/A'}</p>
                                        {app.status == "rejected" &&
                                        <p style={{ marginBottom: '0px' }}><strong>Lost Reason:</strong> {app.lostReason || 'N/A'}</p>}
                                        
                                    </li>
                                ))
                                }
                            </ol>
                        </div> 
                    </div>
                    {/* {constitutionType + constSubmit} */}
                    {
                        ((gstArr["gstin_number"] && gstArr["gstin_number"].length > 5 && gstArr["gstin_number"].charAt(5) === "P") || (constitutionType == 'Proprietor' && constSubmit)) && 
                        <PropComponent states={stateValues}></PropComponent>
                    }
                    {
                        ((gstArr["gstin_number"] && gstArr["gstin_number"].length > 5 && gstArr["gstin_number"].charAt(5) === "F") || (constitutionType == 'Partnership'  && constSubmit)) && 
                        <PartnerComponent states={stateValues}></PartnerComponent>
                            
                    }
                    {
                        ((gstArr["gstin_number"] && gstArr["gstin_number"].length > 5 && gstArr["gstin_number"].charAt(5) === "C") || (constitutionType == 'Company'  && constSubmit)) && 
                        <CompanyComponent states={stateValues}></CompanyComponent>
                    }

                    {
                        ( (constitutionType === '' || !constSubmit) && (!gstArr["gstin_number"] || gstArr["gstin_number"].charAt(5) != "C" && gstArr["gstin_number"].charAt(5) != "P" &&  gstArr["gstin_number"].charAt(5) != "F")) &&

                        <div id="constType" style={{...styles.midSection,textAlign:'center',width:'32%',margin:'0 auto',minHeight:'100px',marginBottom:'50px'}}>
                            <label style={{fontWeight:'bold'}}>
                                Enter Constitution Type : 
                            </label>

                            <br/>

                            <label className="constTypeRadio">
                                <input
                                    type="radio"
                                    value="Proprietor"
                                    checked={constitutionType === "Proprietor"}
                                    onChange={handleConstitutionChange}
                                    style={{marginRight:'2px'}}
                                />
                                Proprietor
                            </label>

                            <label className="constTypeRadio">
                                <input
                                    type="radio"
                                    value="Partnership"
                                    checked={constitutionType === "Partnership"}
                                    onChange={handleConstitutionChange}
                                    style={{marginRight:'2px'}}
                                />
                                Partnership
                            </label>

                            <label className="constTypeRadio">
                                <input
                                    type="radio"
                                    value="Company"
                                    checked={constitutionType === "Company"}
                                    onChange={handleConstitutionChange}
                                    style={{marginRight:'2px'}}
                                />
                                Company
                            </label>

                            <button style={{backgroundColor:'#007BFF',color:'#FFF',borderRadius:'8px',border:'none',padding:'4px 10px'}} onClick={handleConstitutionSubmitClick}>SUBMIT</button>
                        </div>
                    }
                    
                    {showTimelineDetails && (
                       <Modal
                       show={showTimelineDetails}
                       centered
                       dialogClassName="custom-modal-bank" // Custom class for styling
                       onHide={handleAppTimelineClose}
                     >
                       <Modal.Header closeButton>
                         <h3>Application Progress for {selectedTimeLender}</h3>
                       </Modal.Header>
                        
                       <Modal.Body>
                         {newAppTime && newAppTime.length > 0 && (
                            <>

                          { newAppTime
                             .filter((app) => app.appId === selectedAppId && app.event !== "" && (app.event.toLowerCase() === "application created" || app.event.toLowerCase() === "stage updated")) 
                             .map((app, index, arr) => (
                                
                               <div key={index} className="timeline-container container">
                                 <div className="row">
                                    
                                    { renderFinalStatus(app.status,app.lostReason) }
                                    {/* Index is {index} */}
                                    {
                                        (index > 0 && app.event.toLowerCase() === "stage updated") &&
                                        <div className="days-difference-box">
                                            <div>
                                                {calculateDaysDifference(arr[index - 1].date, app.date)}{" "}
                                                {calculateDaysDifference(arr[index - 1].date, app.date) === 1 ? "day" : "days"}
                                            </div>
                                        </div>
                                    }
                                    {
                                        (index > 0 && app.event.toLowerCase() === "application created") &&
                                        <div className="days-difference-box">
                                            <div>
                                                {calculateDaysDifference(arr[index - 1].date, app.appDate, 'dd')}{" "}
                                                {calculateDaysDifference(arr[index - 1].date, app.appDate, 'dd') === 1 ? "day" : "days"}
                                            </div>
                                        </div>
                                    }

                                    <div className="col-2" style={{ display: 'flex', alignItems: 'center', flexDirection:'column' }}>
                                    <div className="vertical-line1"></div>
                                        <div className="circle-container">
                                                <div className="big-circle">
                                                    <div className="small-circle">
                                                        <span className="circle-text"></span>
                                                    </div>
                                                </div>
                                        </div>
                                    <div className="vertical-line2"></div>
                                    </div>
                                   <div className="col-7">
                                    <div className="step-details">

                                        <div>
                                            {(app.event.toLowerCase() === "stage updated") && 
                                            <p className="content" style={{ fontWeight:'bold',color:'#000',fontSize:'14px'}}>
                                                {app.oldVal} <span style={{fontWeight:'normal'}}>to</span> {app.newVal}
                                            </p>}
                                            <p style={{color:"#423f3f"}}>{app.event}</p>
                                            <p className="content">
                                                {app.event.toLowerCase() === "application created" &&
                                                app.appDate ? formatDate(new Date(app.appDate)) : ""}
                                                {app.event.toLowerCase() === "stage updated" &&
                                                app.date ? formatDate(new Date(app.date)) : ""}
                                            </p>
                                       </div>
                                     
                                   </div>
                                   </div>
                                    {/* {app.stage} */}
                                    { 
                                        ( (app.stage === "Approved" || app.stage === "Disbursed") && 
                                        app.status.toLowerCase() !== "rejected"
                                        ) && 
                                        renderLoanTable(app.loanAmt, app.loanRate, app.loanTenure)
                                    }
                                    
                                    {
                                        renderTAT(app.appDate,newAppTime[0].date,app.status,app.appId)
                                    }
                                   
                                 </div>
                               </div>
                             ))}

                                
                             </>
                         )}
                       </Modal.Body>
                     </Modal>
                     
                     
                    )}
                </>
            }

            {
                isUploaded !== 'No' &&
                <Modal 
                    show={show}
                    centered
                    dialogClassName="custom-modal-bank" // Add a custom class for styling the modal
                    id="custom-modal-bank"
                    onHide={() => setShow(false)}
                >   
                <Modal.Header closeButton>
                    <div style={{fontWeight:'bold',fontSize:'18px'}}>List of PDF</div>
                </Modal.Header>

                <Modal.Body>
                        <table 
                            border="1" 
                            style={{ 
                                width: '100%', 
                                borderCollapse: 'collapse', 
                                textAlign: 'center',
                                border: '2px solid black' // Add a thicker border around the table
                            }}
                        >
                            <thead>
                                <tr style={{...styles.pdfTable}}>
                                    <th style={{...styles.pdfTableHeader}}>S No.</th>
                                    <th style={{...styles.pdfTableHeader}}>Doc Stage</th>
                                    <th style={{...styles.pdfTableHeader}}>Doc Name</th>
                                    <th style={{...styles.pdfTableHeader}}>Duration</th>
                                    <th style={{...styles.pdfTableHeader}}>Upload Date</th>
                                    <th style={{...styles.pdfTableHeader}}>Password</th>
                                    <th style={{...styles.pdfTableHeader}}>View/Download</th>
                                </tr>
                            </thead>
                            <tbody>
                                {bankArrState.map((entry, index) => (
                                    <tr style={{border:'1px solid black'}} key={index}>
                                        <td style={{...styles.pdfTableContent}}>{index+1}</td>
                                        <td style={{...styles.pdfTableContent}}>{entry.docStage}</td>
                                        <td style={{...styles.pdfTableContent}}>{entry.docName}</td>
                                        <td style={{...styles.pdfTableContent}}>{entry.duration}</td>
                                        <td style={{...styles.pdfTableContent}}>{formatDate(entry.uploadDate)}</td>
                                        <td style={{...styles.pdfTableContent}}>{entry.pswrd}</td>
                                        <td style={{...styles.pdfTableContent}}> <i class="bi bi-box-arrow-up-right" onClick={() => handleDownloadClick(bankArrState[index]["docUrl"])} style={{cursor:'pointer'}}></i> </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </Modal.Body>
                </Modal>

            }
        </>    
    );
}

const styles = {
    container: {
        padding: '20px',
        borderRadius: '8px',
        maxWidth: '270px',
        position:'absolute',
        top:'40%',
        left:'40%',
        backgroundColor:'#f5f5f5',
        fontFamily:'Manrope'
    },
    table: {
        width: '100%',
        marginBottom: '20px',
    },
    label: {
        paddingRight: '10px',
        fontWeight: 'bold',
    },
    input: {
        width: '100%',
        padding: '8px',
        borderRadius: '4px',
        border: '1px solid #ccc',
    },
    button: {
        padding: '10px 20px',
        backgroundColor: '#007BFF',
        color: '#fff',
        border: 'none',
        borderRadius: '4px',
        cursor: 'pointer',
    },
    radioGroup: {
        marginBottom: '20px',
    },
    radioLabel: {
        display: 'block',
        marginBottom: '10px',
    },
    radio: {
        marginRight: '8px',
    },
    authContainer: {
        textAlign: 'center',
    },
    uiContainer: {
        textAlign: 'left',
    },
    midSection : {
        backgroundColor:'#A2CFFF',
        // height:'200px',
        borderRadius:'8px',
        margin:'20px',
        padding:'20px',
        fontSize:'14px'
    },
    allSec : {
        width:'25%',
        backgroundColor:'#A2CFFF',
        borderRadius:'8px',
        margin:'20px',
        padding:'20px',
        fontSize:'14px'
    },
    bankingCTA:{
        marginBottom: '10px',
        padding: '4px 8px',
        border: 'none',
        borderRadius: '5px',
        backgroundColor: '#007BFF', // Button color
        color: '#FFF', // Text color
        fontSize: '16px',
        cursor: 'pointer',
        transition: 'background-color 0.3s ease',
        // margin:'5px'
    },
    // fileInput: {
    //     opacity: 0, 
    //     position: 'absolute', 
    //     zIndex: 1, 
    //     width: '100%', 
    //     height: '100%',
    //     cursor: 'pointer'
    // },
    customButton: {
        display: 'inline-block',
        padding: '4px 8px',
        borderRadius: '5px',
        backgroundColor: '#007BFF',
        color: '#FFF',
        fontSize: '16px',
        cursor: 'pointer',
        margin:'5px'
    },
    datePicker : {
        padding: '4px',
        borderRadius: '5px',
        border: '1px solid #007BFF',
        backgroundColor: '#FFF',
        color: '#333',
        fontSize: '14px',
        marginRight: '10px'
    },
    pdfTableContent : {
        border:'1px solid black'
    },
    pdfTableHeader : {
        border:'2px solid black'
    },
    loanDet: {
        // width: '100%',
        borderCollapse: 'collapse',
        margin: '10px 0',
        boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
        backgroundColor: '#fff',
        borderRadius: '8px',
    },
    labelCell: {
        padding: '4px 6px',
        backgroundColor: '#f7f9fc', // light grey for labels
        color: '#333',
        fontWeight: '600',
        borderBottom: '2px solid #e0e0e0',
        textAlign: 'left',
        borderRadius: '8px 0 0 8px', // rounded left corners
    },
    valueCell: {
        padding: '6px 20px',
        backgroundColor: '#fff',
        color: '#333',
        textAlign: 'center',
        fontWeight: '500',
        borderBottom: '2px solid #e0e0e0',
        borderRadius: '0 8px 8px 0', // rounded right corners
    },
    tatContainer: {
        margin: '10px 0', 
        position: 'absolute', 
        right: '120px', 
        width: '20%',
        padding: '4px 6px',
        backgroundColor: '#f7f9fc', 
        borderRadius: '8px', 
        boxShadow: '0 4px 10px rgba(0, 0, 0, 0.1)', 
        color: '#333', 
        fontWeight: '600',
        fontSize: '16px', 
        textAlign: 'center',
        border: '1px solid #e0e0e0', 
        transition: 'all 0.3s ease', 
    },
    countingText: {
        marginBottom: '0px', 
        color: '#ff5733', 
        fontWeight: '500',
        fontSize: '14px',
    },
    googleButton: {
        display: 'flex',
        alignItems: 'center',
        padding: '10px 20px',
        borderRadius: '5px',
        border: 'none',
        cursor: 'pointer',
        backgroundColor: '#4285F4', 
        color: '#fff',
        fontSize: '16px',
        fontWeight: 'bold',
        transition: 'background-color 0.3s',
        margin:'0 auto'
    },
};

export default CRMComponent;